import { gql } from "@apollo/client";
const USER_BY_DUPRID = gql`
  query checkDuprId($duprId: String!) {
    checkDuprId(duprId: $duprId)
  }
`;
export default USER_BY_DUPRID;
